import { LeftMenuActionTypes, LEFT_MENU_ACTIONS_OPEN, LEFT_MENU_ACTIONS_CLOSE } from "./LeftMenuActionTypes";

export interface ILeftMenuReducer {
  opened: boolean
}

const INITIAL_STATE: ILeftMenuReducer = {
  opened: false
};

export default (state: ILeftMenuReducer = INITIAL_STATE, action: LeftMenuActionTypes) => {
  switch (action.type) {
    case LEFT_MENU_ACTIONS_OPEN:
    case LEFT_MENU_ACTIONS_CLOSE:
      return { ...state, opened: action.payload };
    default:
      return state;
  }
};